export interface AuBase {
    service: string
    page: string
    area: string
}

const createAuBase = (service: string, page: string, area: string): AuBase => {
    return {service, page, area}
}

const auBases = {
    connect: createAuBase('md', 'B', 'B'),
    bank: {
        list: createAuBase('md', 'bank', 'B'),
        empty: createAuBase('md', 'bank_empty', 'E'),
    },
    card: {
        common: createAuBase('md', 'card', 'B'),
        approval: {
            cardList: createAuBase('md', 'card_approval', 'B'),
            list: createAuBase('md', 'approval', 'B'),
            detail: createAuBase('md', 'approval', 'D'),
        },
        empty: createAuBase('md', 'empty', 'B'),
    },
    efin: {
        home: createAuBase('md', 'efin', 'B'),
        empty: createAuBase('md', 'empty', 'E'),
        detail: createAuBase('md', 'efin', 'D'),
    },
    insurance: {
        common: createAuBase('md', 'insu', 'B'),
        coverage: createAuBase('md', 'B', 'B'),
        coverageDetail: createAuBase('md', 'D', 'D'),
        inflow: createAuBase('insu', 'inflow', 'H'),
        homeB: createAuBase('md', 'insu', 'B'),
        homeD: createAuBase('md', 'insu', 'D'),
        homeP: createAuBase('md', 'insu', 'P'),
        homeM: createAuBase('md', 'insu', 'M'),
    },
} as const

export interface AUData {
    'data-au': string
    'data-au-page': string
    'data-au-service': string
}

export const getAuDataInfo = (auBaseInfo: AuBase, auCode: string): AUData => {
    return {
        'data-au': `${auBaseInfo.area}.${auCode}`,
        'data-au-page': auBaseInfo.page,
        'data-au-service': auBaseInfo.service,
    }
}

export const createActionCodeInfo = (impressionActionCode: string, clickActionCode: string) => {
    return {
        impression: impressionActionCode,
        click: clickActionCode,
    }
}

export const auCodes = {
    insurance: {
        list: {
            insuCard: {
                carExpire: createActionCodeInfo('imp_insulist_carinsu', 'click_insulist_carinsu'),
            },
            ogrLogos: {
                travel: createActionCodeInfo('imp_insulist_up1', 'click_insulist_up1'),
                car: createActionCodeInfo('imp_insulist_up2', 'click_insulist_up2'),
                savings: createActionCodeInfo('imp_insulist_up3', 'click_insulist_up3'),
            },
            compareLowest: {
                carInsu: createActionCodeInfo('imp_insulist_down', 'click_insulist_down'),
                savings: createActionCodeInfo('imp_insulist_savingsdown', 'click_insulist_savingsdown'),
                travel: createActionCodeInfo('imp_insulist_traveldown', 'click_insulist_traveldown'),
            },
            notice: {carExpire: createActionCodeInfo('imp_insu_my_list_notice', 'click_insu_my_list_notice')},
        },
        detail: {
            carInsu: {
                guide: createActionCodeInfo('imp_insu_guidebook', 'click_insu_guidebook'),
                expireModal: {compare: createActionCodeInfo('imp_insu_modal', 'click_insu_modal')},
                fee: {compare: createActionCodeInfo('imp_insu_carinsu_button', 'click_insu_carinsu_button')},
            },
        },
        coverage: {
            car: {
                expire: createActionCodeInfo('imp_insu_coverages_button1', 'click_insu_coverages_button1'),
                registered: createActionCodeInfo('imp_insu_coverages_button2', 'click_insu_coverages_button2'),
                unregistered: createActionCodeInfo('imp_insu_coverages_button3', 'click_insu_coverages_button3'),
            },
        },
        coverageDetail: {
            car: {
                compareLowest: createActionCodeInfo('imp_insu_coverages_car_button', 'click_insu_coverages_car_button'),
            },
        },
        tip: {
            compareLowest: {
                carInsu: createActionCodeInfo('imp_insutip_list_carinsu', 'click_insutip_list_carinsu'),
                savings: createActionCodeInfo('imp_insutip_list_savings', 'click_insutip_list_savings'),
                travel: createActionCodeInfo('imp_insutip_list_travel', 'click_insutip_list_travel'),
                pet: createActionCodeInfo('imp_insutip_list_pet', 'click_insutip_list_pet'),
            },
        },
    },
} as const

export default auBases
